import React, { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom'
// core components
import FrequentlyAskedQuestions from "../../../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions";
// import { getIPGeoLocation } from "../../../common/GeneralUtils";
import axios from "axios";
// import Toasts from "../../../components/Toasts/Toasts.js";
import Header from "../../../components/header/header.jsx";
import Footer from "../../../components/footer/footer.jsx";
import HeroHealthcare from "../../../components/Healthcare/HeroHealthcare.jsx";
import ChallengesStrip from "../../../components/Healthcare/ChallengesStrip.jsx";
import ServicesGrid from "../../../components/Healthcare/ServicesGrid.jsx";
import CapabilitiesGrid from "../../../components/Healthcare/CapabilitiesGrid.jsx";
import WhyUsGrid from "../../../components/Healthcare/WhyUsGrid.jsx";
import SegmentsGrid from "../../../components/Healthcare/SegmentsGrid.jsx";
import TechStackGrid from "../../../components/Healthcare/TechStackGrid.jsx";
import ApproachSection from "../../../components/Healthcare/ApproachSection.jsx";
import CTAWithIndustries from "../../../components/Healthcare/CTAWithIndustries.jsx";

const HealthCareScreen = () => {
    const location = useLocation();
    const title = location.pathname || {};
    // const [toasts, setToasts] = useState(null)
    const [pageData, setData] = useState({});
    // const [geoLocationData, setGeoLocationData] = useState(null);

    const getAllIndustriesData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/HealthcareITData.json');
            return setData(res?.data?.find((content) => content?.pageName === title))
            // setData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }

    useEffect(() => {
        // getIPGeoLocation(location.pathname);
        getAllIndustriesData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [title])

    return (
        <div id="main-wrapper">
            <Header />
            <div className="page-wrapper health-care-page-wrapper">
                <div className="container-fluid">
                    <div className="page-content-top">
                        <HeroHealthcare data={pageData?.HeroHealthcare} />
                        <ChallengesStrip data={pageData?.challenges_strip} />
                        <ServicesGrid data={pageData?.services_grid} />
                        <CapabilitiesGrid data={pageData?.capabilities_grid} />
                        <WhyUsGrid data={pageData?.why_us_grid} />
                        <SegmentsGrid data={pageData?.segments_grid} />
                        <TechStackGrid data={pageData?.tech_stack_grid} />
                        <ApproachSection data={pageData?.our_approach} />
                        <FrequentlyAskedQuestions faqData={pageData?.FrequentlyAskedQuestionsData} />
                        <CTAWithIndustries data={pageData?.cta_with_industries} />
                    </div>
                </div>
            </div>
            <Footer />
            {/* {toasts && <Toasts toastsList={toasts} />} */}
        </div>
    );
}

export default HealthCareScreen;
